export default {
    props: {
        isEditing: {
            type: Boolean,
            default: false
        },
        lng: {
            default () {
                return '103.81599968947137';
            }
        },
        lat: {
            default () {
                return '30.78152098571051';
            }
        },
        zoom: {
            type: Number,
            default () {
                return 10.5;
            }
        },
        scale: {
            default () {
                return 1;
            }
        },
        showMap: {
            type: Boolean,
            default: true
        }
    }
}